// Typography design tokens - Based on MTS UX Base Design v1
export const typography = {
  // Font families (exact from UX spec)
  fontFamily: {
    heading: [
      'Montserrat',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto', 
      'Helvetica Neue',
      'Arial',
      'Noto Sans',
      'sans-serif'
    ],
    body: [
      'Inter',
      '-apple-system', 
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue', 
      'Arial',
      'Noto Sans', 
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
      'Noto Color Emoji'
    ],
    mono: [
      'JetBrains Mono', 
      'Fira Code',
      'ui-monospace',
      'SFMono-Regular',
      'Menlo',
      'Monaco',
      'Consolas',
      'Liberation Mono',
      'Courier New',
      'monospace'
    ]
  },

  // Font sizes (exact px values from UX spec)
  fontSize: {
    xs: '12px',     // text-xs
    sm: '14px',     // text-sm 
    base: '16px',   // text-base
    lg: '18px',     // text-lg
    xl: '20px',     // text-xl
    '2xl': '24px',  // text-2xl
    '3xl': '30px',  // text-3xl 
    '4xl': '36px'   // text-4xl
  },

  // Font weights (exact values from UX spec)
  fontWeight: {
    light: '300',     // font-light
    normal: '400',    // font-normal
    medium: '500',    // font-medium
    semibold: '600',  // font-semibold
    bold: '700'       // font-bold
  },

  // Line heights for better readability
  lineHeight: {
    none: '1',
    tight: '1.25',
    snug: '1.375',
    normal: '1.5',
    relaxed: '1.625',
    loose: '2'
  },

  // Letter spacing
  letterSpacing: {
    tighter: '-0.05em',
    tight: '-0.025em', 
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em'
  }
};

// Semantic typography scales for consistent usage
export const textStyles = {
  // Display text (largest headings)
  display: {
    '4xl': {
      fontSize: typography.fontSize['4xl'], // 36px
      fontWeight: typography.fontWeight.bold,
      lineHeight: typography.lineHeight.tight,
      fontFamily: 'heading'
    },
    '3xl': {
      fontSize: typography.fontSize['3xl'], // 30px
      fontWeight: typography.fontWeight.bold,
      lineHeight: typography.lineHeight.tight,
      fontFamily: 'heading'
    },
    '2xl': {
      fontSize: typography.fontSize['2xl'], // 24px 
      fontWeight: typography.fontWeight.semibold,
      lineHeight: typography.lineHeight.tight,
      fontFamily: 'heading'
    }
  },

  // Standard headings
  heading: {
    xl: {
      fontSize: typography.fontSize.xl,     // 20px
      fontWeight: typography.fontWeight.semibold,
      lineHeight: typography.lineHeight.snug,
      fontFamily: 'heading'
    },
    lg: {
      fontSize: typography.fontSize.lg,     // 18px
      fontWeight: typography.fontWeight.semibold, 
      lineHeight: typography.lineHeight.snug,
      fontFamily: 'heading'
    },
    base: {
      fontSize: typography.fontSize.base,   // 16px
      fontWeight: typography.fontWeight.semibold,
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'heading'
    }
  },

  // Body text
  body: {
    lg: {
      fontSize: typography.fontSize.lg,     // 18px
      fontWeight: typography.fontWeight.normal,
      lineHeight: typography.lineHeight.relaxed,
      fontFamily: 'body'
    },
    base: {
      fontSize: typography.fontSize.base,   // 16px
      fontWeight: typography.fontWeight.normal, 
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'body'
    },
    sm: {
      fontSize: typography.fontSize.sm,     // 14px
      fontWeight: typography.fontWeight.normal,
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'body'
    },
    xs: {
      fontSize: typography.fontSize.xs,     // 12px
      fontWeight: typography.fontWeight.normal,
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'body' 
    }
  },

  // Labels and captions
  label: {
    base: {
      fontSize: typography.fontSize.sm,     // 14px
      fontWeight: typography.fontWeight.medium,
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'body'
    },
    sm: {
      fontSize: typography.fontSize.xs,     // 12px 
      fontWeight: typography.fontWeight.medium,
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'body'
    }
  },

  // Code and monospace
  code: {
    base: {
      fontSize: typography.fontSize.sm,     // 14px
      fontWeight: typography.fontWeight.normal,
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'mono'
    },
    sm: {
      fontSize: typography.fontSize.xs,     // 12px
      fontWeight: typography.fontWeight.normal, 
      lineHeight: typography.lineHeight.normal,
      fontFamily: 'mono'
    }
  }
};